import React from 'react'
import styled from 'styled-components'
import { colors, media } from '../styles/vars'

const StyledHeading = styled.div`
width:90%;
margin:0 auto;
padding:5px 20px 2px;
text-align:right;
${
    media.desktop`
    width:initial;
    display:inline-block;
    `
}
`
const ColoredHeading = styled(StyledHeading) `
background-color:${props => props.bgColor};
color:${props => props.color ? props.color : colors.white};
`

const Title = styled.h2`
font-size:2.8rem;
font-weight:700;
span{
    color:${colors.lightblue};
}
${
    media.desktop`
    font-size:4.5rem;
    `
}
`
const Subtitle = styled.h4`
font-size:1.8rem;
`

const SectionHeading = (props) => (
    <ColoredHeading bgColor={props.bgColor} color={props.color}>
        <Title>
            <span>{props.titlePrefix}</span>
            {props.title}
        </Title>
        <Subtitle>{props.subtitle}</Subtitle>
    </ColoredHeading>
);


export default SectionHeading;


// WEBPACK FOOTER //
// ./src/components/SectionHeading.jsx